/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoadLelRrpPricesResponse
 */
export interface LoadLelRrpPricesResponse {
    /**
     * 
     * @type {number}
     * @memberof LoadLelRrpPricesResponse
     */
    numberOfUpdatedProductPlans: number;
}

/**
 * Check if a given object implements the LoadLelRrpPricesResponse interface.
 */
export function instanceOfLoadLelRrpPricesResponse(value: object): value is LoadLelRrpPricesResponse {
    if (!('numberOfUpdatedProductPlans' in value) || value['numberOfUpdatedProductPlans'] === undefined) return false;
    return true;
}

export function LoadLelRrpPricesResponseFromJSON(json: any): LoadLelRrpPricesResponse {
    return LoadLelRrpPricesResponseFromJSONTyped(json, false);
}

export function LoadLelRrpPricesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoadLelRrpPricesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'numberOfUpdatedProductPlans': json['numberOfUpdatedProductPlans'],
    };
}

export function LoadLelRrpPricesResponseToJSON(json: any): LoadLelRrpPricesResponse {
    return LoadLelRrpPricesResponseToJSONTyped(json, false);
}

export function LoadLelRrpPricesResponseToJSONTyped(value?: LoadLelRrpPricesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'numberOfUpdatedProductPlans': value['numberOfUpdatedProductPlans'],
    };
}

